const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Loading chunk',
  'ChunkLoadError',
]

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const message = (error as Error).message || ''
  const name = (error as Error).name || ''
  return CHUNK_ERROR_PATTERNS.some(
    (pattern) => message.includes(pattern) || name.includes(pattern)
  )
}

export interface ImportRetryOptions {
  trackMetric?: (name: string) => void
}

const noop = () => {}

export function createImportRetry(options: ImportRetryOptions = {}) {
  const trackMetric = options.trackMetric ?? noop

  return async function importRetry<T>(
    importFn: () => Promise<T>,
    retries = 2,
    interval = 1000,
    firstTry = true
  ): Promise<T> {
    try {
      const result = await importFn()
      if (!firstTry) {
        trackMetric('lazy_load.retry_success')
      }
      return result
    } catch (error) {
      if (retries > 0) {
        await wait(interval)
        trackMetric('lazy_load.retry')
        return importRetry(importFn, retries - 1, interval, false)
      }

      trackMetric('lazy_load.retry_failure')
      throw error
    }
  }
}
